<template>
  <!-- 人员及资产管理 -> 分配资产 author: zhangxiaofeng -->
  <div class="config-asset--main">
    <!-- 可分配的资产编号授权为0，无法分配资产。 -->
    <w-dialog :show="model.noAsset"
              confirm
              show-close
              class="no-asset-model"
              :box-style="{width: '500px'}"
              title="温馨提示"
              @close="cancel('noAsset')">
      <div class="padding-20-0">
        可分配的资产编号授权为0，无法分配资产。
      </div>
      <template slot="footer">
        <w-button type="primary" @click="submit('noAsset')">确定</w-button>
      </template>
    </w-dialog>

    <!-- 有可分配资产 或 该用户已经分配过资产 -->
    <w-dialog :show="model.hasAsset"
              show-close
              class="has-asset-model"
              :box-style="{width: '900px'}"
              :bodyStyle="{ padding: '20px 24px' }"
              title="资产分配"
              @close="cancel('hasAsset')">
      <div>
        <div class="suffix-reg-tip">
          <p>说明：取消勾选即取消分配，联网或借出使用的产品不可取消分配！</p>
        </div>
        <p class="detail">
          分配员工：{{configItem.account}}
        </p>
        <p class="detail">
          资产分配情况：分配给当前账户 {{selfAsset}} 个，可分配 {{leftoverAsset}} 个
        </p>
        <!--<p>addAsset: {{addAsset}}</p>-->
        <!--<p>deleteAsset: {{deleteAsset}}</p>-->
        <!--<p>checkedBefore: {{checkedBefore}}</p>-->
        <!-- <p style="padding: 12px 0 16px 0;">
          <span class="inline-block" style="width: 75px;">产品名称</span>
          <w-select
            :class="{'is-selected': value.length}"
            size="small"
            v-model="value"
            multiple
            filterable
            remote
            @change="filterChange"
            @visible-change="handleSelectBlur"
            placeholder="请输入产品名称"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width: calc(100% - 75px);">
            <i slot="prefix" class="w__input__icon r2-icon-action_search" style="font-size: 16px !important"></i>
            <div slot="empty" class="text-align-center font-14 cursor-default" style="padding: 58px 74px;line-height: 24px;color: rgba(33, 37, 48, 0.35);">
              企业组织内无此产品名称，请尝试<br/>其它关键词进行搜索
            </div>
            <w-option
              v-for="(item, index) in options"
              :key="`${item}_${index}`"
              :label="item"
              :value="item">
            </w-option>
          </w-select>
        </p> -->
        <asset-product-list :config-item="configItem"
                            :loading="loadingAssets"
                            :addAsset="addAsset"
                            @listReady="listReadyHandle"
                            @checkedChange="checkedChangeHandle"
                            :search-condition="searchCondition"
                            :asset-list="assetAll">
        </asset-product-list>
        <p v-if="errorType" class="error-message">{{errorTips[errorType]}}</p>
      </div>
      <template slot="footer">
        <w-button type="primary" @click="submit('hasAsset')" :disabled="saving">确定</w-button>
        <w-button type="minor" @click="handleCancel('hasAsset')">取消</w-button>
      </template>
    </w-dialog>
  </div>
</template>
<style lang="less" type="text/less">
  @import "./index";
</style>
<script>
import configAssetMixins from '@/assets/mixins/config-asset'
import AssetProductList from './AssetProductList'
import manageService from 'service/manage'
import _ from 'lodash'

export default {
  name: 'ConfigAsset',
  mixins: [configAssetMixins],
  data () {
    return {
      popType: 'Asset',
      options: [],
      value: [],
      loading: false,
      loadingAssets: false,
      searchCondition: []
    }
  },
  mounted () {
    this.checkedBefore = {}
    this.setAssetList([])
    // this.remoteMethod()  --2020.9.9资产管理批量查询产品许可接口性能影响-紧急需求输入 越平邮件输入
  },
  methods: {
    // 选择产品名称后，触发资产列表更新
    filterChange: _.debounce(function (products = []) {
      this.loadingAssets = true
      const start = Date.now()
      this.searchAssetList(Object.assign({}, this.configItem, {products})).then(() => {
        this.sentLog(100117076, {message: products.join(','), duration: ((Date.now() - start) / 1000).toFixed(2)})
        this.loadingAssets = false
        this.searchCondition = products
      }).catch(() => {
        this.loadingAssets = false
      })
    }, 500),
    // 选择产品名称列表下拉框隐藏时
    handleSelectBlur (status) {
      // if (!status) {
      //   setTimeout(() => {
      //     this.options = this.list
      //   }, 300)
      // }
    },
    // 搜索产品名称
    remoteMethod (query = '') {
      this.loading = true
      manageService.getPackagesByProductName({keyword: query}).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.options = res.data
        } else {
          this.options = []
        }
      }).catch(() => {
        this.loading = false
        this.options = []
      })
    },
    // 1. 显示 分配产品弹窗
    showConfigPop () {
      if (this.assetAll.length) {
        // 有已分配资产 或 有可分配资产
        this.model.hasAsset = true
      } else {
        // 无可用资产
        // this.model.noAsset = true
        this.$message.warning('可分配的资产编号授权为0，无法分配资产')
      }
    },
    // 2.1 弹窗 确定
    submit (type) {
      if (this.saving) return
      if (type === 'noAsset') {
        this.cancel(type)
        // return
      } else {
        if (!this.checkedAssetChange) {
          for (const key in this.checkedBefore) {
            this.addAsset.push(this.checkedBefore[key])
          }
        }
        if (this.addAsset.length || this.deleteAsset.length) {
          const params = {
            addAssets: this.addAsset,
            deleteAssets: this.deleteAsset
          }
          this.saving = true
          manageService.configAssetForUser(this.configItem.gldUserId, params).then((data) => {
            // console.log(data)
            if (+data.code === 200) {
              if (this.addAsset.length) {
                manageService.addRelationLog({
                  area: this.userInStore.area,
                  detail: `${this.configItem.account}-${this.addAsset.join(',')}`,
                  operateType: 'ASSET_ALLCATION',
                  relType: '',
                  showState: 1
                })
                this.sentLog(100117030, {result: this.configItem.account + '-' + this.addAsset.join(','), type: 1})
              }
              if (this.deleteAsset.length) {
                const cancelAsset = this.deleteAsset.filter(assetNum => {
                  return this.checkedAsset.includes(assetNum)
                })
                manageService.addRelationLog({
                  area: this.userInStore.area,
                  detail: `${this.configItem.account}-${cancelAsset.join(',')}`,
                  operateType: 'ASSET_CANCEL',
                  relType: '',
                  showState: 1
                })
                this.sentLog(100117030, {result: this.configItem.account + '-' + cancelAsset.join(','), type: 0})
              }
              this.model[type] = false
              this.checkedBefore = {}
              this.setAssetList([])
              this.$emit('submit', this.popType)
            } else {
              this.showErrorMessage(data.code)
            }
            this.saving = false
          }).catch((e) => {
            console.log(e)
            this.showErrorMessage(340022)
            this.saving = false
          })
        } else {
          this.cancel(type)
        }
      }
    },
    // 2.2 弹窗 取消
    handleCancel (type) {
      this.cancel(type)
    }
  },
  components: {
    AssetProductList
  }
}
</script>
